import React, { useEffect, useState, useRef } from "react";
import AuthNavComponent from "../module/auth/AuthNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import CleanerDocuments from "./CleanerDocuments";
import CleanerReference from "./CleanerReference";
import CleanerEmployment from "./CleanerEmployment";
import JobType from "./JobType";
import CleanerTraining from "./CleanerTraining";
import CleanerMedicalCondition from "./CleanerMedicalCondition";
import CleanerPreferences from "./CleanerPreferences";
import { FormattedMessage, useIntl } from "react-intl";
import {
  faMapMarker,
  faBriefcase,
  faEnvelope,
  faPhone,
  faPencil,
  faLock,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Footer from "../module/Footer";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getReference } from "sr/utils/api/cleaner/getReference";
import { getEmployment } from "sr/utils/api/cleaner/getEmployment";
import { getJobType } from "sr/utils/api/cleaner/getJobType";
import { getMedicalCondition } from "sr/utils/api/cleaner/getMedicalCondition";
import { getTraining } from "sr/utils/api/cleaner/getTraining";
import { getPreferences } from "sr/utils/api/cleaner/getPreferences";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { FindCurrentEmployer } from "sr/helpers/functions/FindCurrentEmployer";
import { StringLoader } from "../component/Loader/StringLoader";
import { uploadFile } from "sr/utils/api/uploadFile";
import { getFiles } from "sr/utils/api/getFiles";
import { getFile } from "sr/utils/api/getFile";
import PhoneNumberFormat from "sr/helpers/functions/PhoneNumberFormat";
import { EmpoymentDuration } from "sr/helpers/functions/EmpoymentDuration";
import { DownloadResume } from "sr/helpers/functions/ApiFunction.tsx/DownloadResume";
import CleanerPersonalInfo from "./CleanerPersonalInfo";
import CleanerPersonalDetails from "./component/CleanerPersonalDetails";
import { validateFile } from "sr/helpers/functions/validateFile";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { ModelWrapperWithButton } from "../company/component/ModelWrapperWithButton";
import Availability from "./Availability";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { getAvailability } from "sr/utils/api/cleaner/getAvailability";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { deleteReference } from "sr/utils/api/cleaner/deleteReference";
import { deleteJobType } from "sr/utils/api/cleaner/deleteJobType";
import { deleteTraining } from "sr/utils/api/cleaner/deleteTraining";
import { deleteMedical } from "sr/utils/api/cleaner/deleteMedical";
import { deletePreference } from "sr/utils/api/cleaner/deletePreference";
import { deleteEmployment } from "sr/utils/api/cleaner/deleteEmployment";
import { Pageination } from "sr/helpers/ui-components/Pageination";
import { Days } from "../company/work-order/component/Days";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { StringTimeFormat } from "sr/helpers/functions/StringTimeFormat";
import { deleteAvailability } from "sr/utils/api/cleaner/deleteAvailability";
import { VerifyOTP } from "../module/auth/VerifyOTP";
import { sendOTP } from "sr/utils/api/sendOTP";
import { getIndIntersted } from "sr/utils/api/cleaner/indInterested/getIndIntersted";
import PasswordChange from "../individual/AccountSetting/component/models/PasswordChange";
import PasswordChangeCleaner from "./PasswordChangeCleaner";
import SmartSearchSelect from "sr/helpers/ui-components/SmartSearchSelect";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";
import { updateCleaner } from "sr/utils/api/cleaner/updateCleaner";
import { fetchcleaner } from "sr/redux/reducers/cleaner";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "sr/redux/store";
import { getUserFullProfile } from "sr/utils/api/user/user";
import AddStripeConnectAccount from "./AddStripeConnectAccount";
import {
  BACKGROUND_CHECK_STATUSES,
  STRIPE_ONBOARDING_STATUSES,
} from "sr/constants/common";
import { Link, useSearchParams } from "react-router-dom";
import { focusAndScrollToDiv } from "sr/utils/helper";
import { Button } from "sr/helpers/ui-components/company/Button";
import { toast } from "react-toastify";
import RegionSelector from "../component/RegionSelector";
import { deleteRegion } from "sr/utils/api/user/deleteRegion";
import { getRegion } from "sr/utils/api/user/getRegion";
import { deleteUser } from "sr/utils/api/user/deleteUser";
import { useAuth } from "../module/auth";
import { getCheckrPackage } from "sr/utils/api/checkr/getCheckrPackage";
import moment from "moment";
import { startCheckrProcess } from "sr/utils/api/checkr/startCheckrProcess";
import {
  clearEmailVerificationPending,
  isEmailVerificationPending,
} from "sr/helpers/functions/emailVerificationOverride";
import { getBackgroundCheckStatus } from "sr/utils/api/checkr/getBackgroundCheckStatus";
import { getCheckrInvitationLink } from "sr/utils/api/checkr/getCheckrInvitationLink";
import CleanerBackgroundCheck from "./CleanerBackgroundCheck";
import { Payment } from "../company/settings/Components/Payment";
export default function CleanerProfileNew() {
  const isLegacyCheckrCheckoutEnabled = false;
  const [showModal, setShowModal] = React.useState(false);
  const [showPasswordModal, setShowPasswordModal] = React.useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [activeComponent, setActiveComponent] = useState<any>({});
  const [profileImg, setProfileImg] = useState(null);
  const [cleanerId, setCleanerId] = useState();
  const [reference, setRefrence] = useState<any>();
  const [employment, setEmployment] = useState<any>();
  const [jobType, setJobType] = useState<any>();
  const [training, setTraining] = useState<any>();
  const [medicalCondition, setMedicalCondition] = useState<any>();
  const [preference, setPreference] = useState<any>();
  const [popuptype, setpopupType] = useState("");
  const [id, setId] = useState("");
  const [resume, setResume] = useState();
  const [pdfData, setPdfData] = useState(null);
  const [cleanerData, setCleanerData] = useState<any>({});
  const [loader, setLoader] = useState("");
  const [resumeName, setResumeName] = useState("");
  const [currentEmployer, setCurrentEmployer] = useState(null);
  const [resumeKey, setResumeKey] = useState(null);
  const [experienceCount, setExperienceCount] = useState(null);
  const [fileerror, setFileError] = useState(null);
  const [showReplace, setShowReplace] = useState(false);
  const [availability, setAvailability] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, settotalPage] = useState<number>(0);
  const [channel, setChannel] = useState<string>("");
  const [noresInterested, setNoResInterested] = useState(false);
  const [regionId, setRegionId] = useState<any>(null);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const [nearbyRegions, setNearbyRegions] = useState<any[]>([]);
  const [showAllRegions, setShowAllRegions] = useState(false);
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [deleteAccountLoader, setDeleteAccountLoader] = useState(false);
  const [checkrInvitationDetail, setCheckrInvitationDetail] = useState(null);

  const intl = useIntl();
  const { logout } = useAuth();
  const trainingSectionLabel = intl.formatMessage({
    id: "CLEANER.REGISTER.TRAINING_CERTIFICATIONS.TITLE",
    defaultMessage: "Trainings & Certifications",
  });

  const [userId, setUserId] = useState<string>("");
  const isEmailVerified =
    cleanerData?.isEmailVerified === true &&
    !isEmailVerificationPending("cleaner", userId, cleanerData?.email);
  const [reload, setReload] = useState<boolean>(true);
  const [checkrPackageDetail, setCheckrPackageDetail] = useState<any>({
    _id: null,
    planName: "",
    price: 89.99,
    extraCharge: 0,
    currencySymbol: "$",
    duration: 1,
    durationType: "Year",
    planTitle: "Basic Plan",
  });
  const dispath = useDispatch<AppDispatch>();
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const appSettingsReloadSetting = useSelector(
    (s: RootState) => s.appSettings.reloadSetting,
  );
  // console.log("appSettingsData", appSettingsData);
  const [searchParams] = useSearchParams();
  const isStripeSetupComplete =
    !!userFullProfile?.stripe_customer_model?.stripe_connect_ac_id &&
    !!userFullProfile?.stripe_customer_model?.stripe_onboarding_status &&
    userFullProfile?.stripe_customer_model?.stripe_onboarding_status ===
      STRIPE_ONBOARDING_STATUSES.SUCCESS;

  useEffect(() => {
    (async () => {
      const getdetails = await getUserDetails();
      setUserId(getdetails?.user_id);
      const getcheckrpackage = await getCheckrPackage("complete_criminal");
      if (getcheckrpackage.success == true) {
        setCheckrPackageDetail(getcheckrpackage?.data);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const userFullProfileRes = await getUserFullProfile();

      const res = await getRegion();
      setNearbyRegions(res?.data);
      setUserFullProfile(userFullProfileRes?.data);
      let userFullProfileDetail = userFullProfileRes?.data;
      if (
        userFullProfileDetail?.user_type_detail?.backgroundCheckStatus !=
          "NOT_STARTED" &&
        [BACKGROUND_CHECK_STATUSES.INVITED].indexOf(
          userFullProfileDetail?.user_type_detail?.backgroundCheckStatus,
        ) !== -1 &&
        userFullProfileDetail?.user_type_detail?.checkrBackgroundCheckDetails
          ?.status &&
        [BACKGROUND_CHECK_STATUSES.INVITED].indexOf(
          userFullProfileDetail?.user_type_detail?.checkrBackgroundCheckDetails
            ?.status,
        ) !== -1
      ) {
        const getBackgroundCheckStatusRes = await getBackgroundCheckStatus(
          userFullProfileDetail?.user_type_detail._id,
        );
        if (getBackgroundCheckStatusRes.success == true) {
          console.log(
            "getBackgroundCheckStatusRes?.data",
            getBackgroundCheckStatusRes?.data,
          );
          if (getBackgroundCheckStatusRes?.data?.invitationDetail) {
            setCheckrInvitationDetail(
              getBackgroundCheckStatusRes?.data.invitationDetail,
            );
          } else {
            setCheckrInvitationDetail(null);
          }
        }
      }
    })();
  }, [reload, appSettingsReloadSetting]);

  const HandleModel = (data: any) => setShowPasswordModal(data);

  const fetchReference = async (cleanerId) => {
    setLoader("Reference");
    const referenceData = await getReference(cleanerId, undefined);

    if (referenceData?.success) {
      setRefrence(referenceData.data);
      setLoader("");
    }
  };

  const handleRegionChange = (selectedItem: any) => {
    if (selectedItem && selectedItem.length) {
      setRegionIdMe(selectedItem);
      setRegionId(selectedItem);

      const payload = {
        id: userId,
        regionId: selectedItem,
      };
      updateCleaner(payload).then((result) => {
        if (result?.success) {
          dispath(fetchcleaner({ id: userId }));
        }
      });
    } else {
      setRegionIdMe(selectedItem);
      setRegionId(selectedItem);
    }
  };

  const handleOptOutChange = (optOutStatus: any) => {
    if (optOutStatus !== undefined) {
      const payload = {
        id: userId,
        sms_opt_out: optOutStatus,
      };
      setLoader("Profile");
      updateCleaner(payload).then(async (result) => {
        if (result?.success) {
          await fetchCleaner(userId);
        }
      });
      setLoader("");
    }
  };

  const fetchCleaner = async (cleanerId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("id", cleanerId);
    setLoader("Profile");
    const cleanerData = await getCleaner(queryParams);

    if (cleanerData?.success) {
      setRegionId(cleanerData.data?.regionId?.id);
      setCleanerData(cleanerData.data);
      setLoader("");
    }
  };

  const fetchEmploymentData = async (cleanerId) => {
    setLoader("Employment");
    const employmentData = await getEmployment(cleanerId, undefined);

    if (employmentData?.success) {
      setEmployment(employmentData?.data);
      const totalex = EmpoymentDuration(employmentData?.data);
      setExperienceCount(totalex);
      setCurrentEmployer(FindCurrentEmployer(employmentData.data));
      setLoader("");
    }
  };

  const fetchJobTypeData = async (cleanerId) => {
    setLoader("Job Type");
    const jobTypeData = await getJobType(cleanerId, undefined, page, limit);

    if (jobTypeData?.success) {
      setJobType(jobTypeData.data);
      settotalPage(Math.ceil(jobTypeData?.pagination.total / limit));
      setLoader("");
    }
  };
  useEffect(() => {
    if (cleanerId) {
      fetchJobTypeData(cleanerId);
    }
  }, [page]);

  const fetchMedicalConditionData = async (cleanerId) => {
    setLoader("Medical Conditions");
    const medicalConditionData = await getMedicalCondition(
      cleanerId,
      undefined,
    );

    if (medicalConditionData?.success) {
      setMedicalCondition(medicalConditionData.data);
      setLoader("");
    }
  };

  const fetchTrainingData = async (cleanerId) => {
    setLoader("Training");
    const trainingData = await getTraining(cleanerId, undefined);

    if (trainingData?.success) {
      setTraining(trainingData.data);
      setLoader("");
    }
  };

  const fetchPreferenceData = async (cleanerId) => {
    setLoader("Preferences");
    const preferenceData = await getPreferences(cleanerId, undefined);

    if (preferenceData?.success) {
      setPreference(preferenceData.data);
      setLoader("");
    }
  };
  const fetchProfileImg = async (cleanerId) => {
    const params = {
      cleaner_id: cleanerId,
    };
    const profileImg = await getFiles(params);
    if (profileImg?.success === true) {
      const filterfile = profileImg?.data?.filter(
        (item) => item?.file?.fieldname === "profile_img",
      );
      if (filterfile && filterfile[0]?.file?.key) {
        const fileimg = await getFile(filterfile[0]?.file?.key);
        if (fileimg) {
          // const rawImageData = new Uint8Array(fileimg as ArrayBuffer);
          // const blob = new Blob([rawImageData], { type: 'image/png' });
          const newImageUrl = URL.createObjectURL(fileimg);
          setProfileImg(newImageUrl);
          return true;
        }
      }
    }
  };
  const fetchAvailability = async (cleanerId) => {
    try {
      setLoader("Availability");
      const queryParams = new URLSearchParams();
      queryParams.append("cleaner_id", cleanerId);
      const res = await getAvailability(queryParams);
      if (res?.success === true) {
        setAvailability(res?.data[0]?.availability);
        setLoader("");
      } else {
        setLoader("");
      }
    } catch (e: any) {
      HandleApiError(e);
      setLoader("");
    }
  };

  const dataAddedHandle = async (data) => {
    if (data === true || data?.emailVerificationPending) {
      setShowModal(false);
      if (cleanerId) {
        switch (activeComponent.label) {
          case "Reference":
            fetchReference(cleanerId);
            break;
          case "Employment":
            fetchEmploymentData(cleanerId);
            break;

          case "Job Type":
            fetchJobTypeData(cleanerId);
            getInterested(cleanerId);
            break;

          case trainingSectionLabel:
            fetchTrainingData(cleanerId);
            break;

          case "Medical Conditions":
            fetchMedicalConditionData(cleanerId);
            break;

          case "Preferences":
            fetchPreferenceData(cleanerId);
            break;
          case "Personal Details":
            await fetchCleaner(cleanerId);
            break;
          case "Personal Info":
            await fetchCleaner(cleanerId);
            break;
          case "Availability":
            fetchAvailability(cleanerId);
            break;
          case "Regions":
            setReload(!reload);
            break;
        }
      }
      setId("");
      setpopupType("");
      if (data?.emailVerificationPending) {
        localStorage.setItem("RegisterAs", "Cleaner");
        setChannel("email");
        setShowVerify(true);
        handleOtpVerify("email", data?.username);
      }
    }
  };

  const dataAddedHandleEditMultiple = () => {
    setShowModal(false);
    getInterested(cleanerId);
    fetchJobTypeData(cleanerId);
  };

  useEffect(() => {
    const getdetails = getUserDetails();

    if (getdetails) {
      setCleanerId(getdetails.user_id);
    }
  }, []);
  const fetchResumeFile = async () => {
    setLoader("Resume");
    const params = {
      cleaner_id: cleanerId,
    };
    const resumefile = await getFiles(params);
    if (resumefile?.success === true) {
      const filterfile = resumefile?.data?.filter(
        (item) => item?.file?.fieldname === "resume",
      );
      if (filterfile) {
        setResumeName(filterfile[0]?.file?.originalname);
        setResumeKey(filterfile[0]?.file?.key);
      }
      setLoader("");
    } else {
      setLoader("");
    }
  };

  const leftNav = [
    { label: "Personal Info", componentName: CleanerPersonalInfo }, //0
    { label: "Employment", componentName: CleanerEmployment }, //1
    { label: "Reference", componentName: CleanerReference }, //2
    { label: "Job Type", componentName: JobType }, //3
    {
      label: trainingSectionLabel,
      componentName: CleanerTraining,
    }, // 4
    // {
    //   label: "Medical Conditions",
    //   componentName: CleanerMedicalCondition,
    // },
    {
      label: "Preferences",
      componentName: CleanerPreferences, //5
    },

    { label: "Availability", componentName: Availability }, //6
    {
      label: "Personal Details",
      componentName: CleanerPersonalDetails, //7
    },
    {
      label: "Change Password",
      componentName: PasswordChange, //8
    },
    {
      label: "My Stripe Account",
      componentName: AddStripeConnectAccount, //9
    },
    {
      label: "Regions",
      componentName: RegionSelector, //10
    },
    {
      label: "Background Check",
      componentName: AddStripeConnectAccount, //11
    },
  ];
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        //setLatLng(position.coords.latitude + "," + position.coords.longitude);
      },
      function (error) {
        console.error("Error Code = " + error.code + " - " + error.message);
      },
    );
  }, []);

  const openPopup = (index: any) => {
    const activeComp = leftNav.filter(function (e, i) {
      return i === index;
    });
    setActiveComponent(activeComp[0]);

    setShowModal(true);
  };

  const scrollToSection = (id: any) => {
    if (id) {
      const section = document.getElementById("section-" + id);
      section?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const onCheckModel = () => {
    setShowModal(false);
    setId("");
    setpopupType("");
  };

  const HandleImage = async (e: any) => {
    try {
      setLoader("imagefetch");
      const file: any = e.target.files[0];
      const formData = new FormData();
      formData.append("cleaner_id", cleanerId);
      formData.append("profile_img", file);
      const result = await uploadFile(formData);
      if (result?.success === true) {
        if (profileImg) {
          SuccessMessage("API.SUCCESS.PROFILE.IMG.UPDATE");
        } else {
          SuccessMessage("API.SUCCESS.PROFILE.IMG.UPLOAD");
        }

        await fetchProfileImg(cleanerId);
        setLoader("");
      } else {
        setLoader("");
      }
    } catch (e: any) {
      setLoader("");
    }
  };
  useEffect(() => {
    if (cleanerId) {
      fetchResumeFile();
    }
  }, [cleanerId]);
  useEffect(() => {
    const fetchData = async () => {
      if (cleanerId) {
        await fetchCleaner(cleanerId);
        await fetchReference(cleanerId);
        await fetchEmploymentData(cleanerId);
        await fetchJobTypeData(cleanerId);
        await fetchTrainingData(cleanerId);
        await fetchMedicalConditionData(cleanerId);
        await fetchPreferenceData(cleanerId);
        await fetchAvailability(cleanerId);
        await fetchProfileImg(cleanerId);
        if (searchParams.get("tab")) {
          console.log(searchParams.get("tab"));
          focusAndScrollToDiv(searchParams.get("tab"));
        }
      }
    };

    fetchData();
  }, [cleanerId]);

  const childRef = useRef(null);

  const HandleChange = async () => {
    if (childRef.current && (childRef.current as any).submitForm) {
      await (childRef.current as any).submitForm();
    }
    // fetchData();
  };

  const handleButtonClick = () => {
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }
  };
  const HandleResume = async (e: any) => {
    try {
      const file = e.target.files[0];
      const check = validateFile(file);
      setFileError("");
      if (check !== true) {
        setFileError(check);
        return;
      }
      setLoader("Fileupload");
      const data = new FormData();
      data.append("cleaner_id", cleanerId);
      data.append("resume", e.target.files[0]);
      const result = await uploadFile(data);
      if (result.success === true) {
        setLoader("");
        SuccessMessage("API.SUCCESS.RESUME.UPLOAD");
        fetchResumeFile();
      }
    } catch (error) {
      setLoader("");
      console.error("Error uploading resume:", error);
    }
  };
  const [jobTypes, setJobTypes] = useState([]);
  useEffect(() => {
    const fetchJobType = async () => {
      try {
        const res = await getJobTypeCategory();
        if (res?.success === true) {
          setJobTypes(res?.data);
        }
      } catch (e: any) {}
    };
    fetchJobType();
  }, []);
  const HandleDelete = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("id", id);

    console.log("activeComponent.label", activeComponent.label);

    try {
      let res;
      switch (activeComponent.label) {
        case "Reference":
          res = await deleteReference(queryParams);
          break;
        case "Employment":
          res = await deleteEmployment(queryParams);
          break;

        case "Job Type":
          res = await deleteJobType({ id });
          break;

        case trainingSectionLabel:
          res = await deleteTraining({ id });
          break;

        case "Medical Conditions":
          res = await deleteMedical(queryParams);
          break;

        case "Preferences":
          res = await deletePreference(queryParams);
          break;
        case "Availability":
          res = await deleteAvailability(queryParams);
      }
      if (res?.success === true) {
        setId("");
        setShowModal(false);
        switch (activeComponent.label) {
          case "Reference":
            fetchReference(cleanerId);
            break;
          case "Employment":
            fetchEmploymentData(cleanerId);
            break;

          case "Job Type":
            fetchJobTypeData(cleanerId);
            break;

          case trainingSectionLabel:
            fetchTrainingData(cleanerId);
            break;

          case "Medical Conditions":
            fetchMedicalConditionData(cleanerId);
            break;

          case "Preferences":
            fetchPreferenceData(cleanerId);
            break;
          case "Personal Details":
            fetchCleaner(cleanerId);
            break;
          case "Personal Info":
            fetchCleaner(cleanerId);
            break;
          case "Availability":
            fetchAvailability(cleanerId);
        }
      }
    } catch (e) {
      HandleApiError(e);
    }
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Optional: Add visual feedback
  };
  const inputRef = useRef(null);
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      HandleResume({ target: { files: [file] } });
      e.dataTransfer.clearData();
    }
  };
  const handlePageChange = (value) => {
    if (value > totalPage || value < 1) {
      return;
    }
    setPage(value);
  };
  const handleOtpVerify = async (
    channel: string,
    username = cleanerData?.username,
  ) => {
    const otpresult = await sendOTP({
      username: username,
      channel: channel,
    });
    if (otpresult?.success === true) {
      localStorage.setItem("RegisterAs", "Cleaner");
      setShowVerify(true);
      setChannel(channel);
    }
  };
  const getInterested = async (cleaner_id) => {
    const queryParams = new URLSearchParams();
    queryParams.append("cleaner_id", cleaner_id);
    const res = await getIndIntersted(queryParams);
    if (res?.success === true) {
      setNoResInterested(res?.data?.interested);
    }
  };
  useEffect(() => {
    if (cleanerId) {
      getInterested(cleanerId);
    }
  }, [cleanerId]);

  useEffect(() => {
    if (searchParams.get("tab")) {
      console.log(searchParams.get("tab"));
      focusAndScrollToDiv(searchParams.get("tab"));
    }
  }, [appSettingsData, cleanerId]);

  const handleDeleteRegion = async (regionId) => {
    const res = await deleteRegion(regionId);
    if (res) {
      toast.success("Region deleted successfully");
    }
    setReload(!reload);
  };

  const handleDeleteAccount = async () => {
    const reason = deleteReason.trim();
    if (!reason) {
      toast.error("Please enter your reason");
      return;
    }

    try {
      setDeleteAccountLoader(true);
      const result = await deleteUser({ reason });

      if (result?.success === true) {
        toast.success("Account deleted successfully");
        setShowDeleteAccountModal(false);
        logout();
      }
    } finally {
      setDeleteAccountLoader(false);
    }
  };

  const sortTrainingItemsByDate = (items: any[] = []) => {
    return [...items].sort((a, b) => {
      const aDate = a?.date_attended ? new Date(a.date_attended).getTime() : 0;
      const bDate = b?.date_attended ? new Date(b.date_attended).getTime() : 0;

      return bDate - aDate;
    });
  };

  const trainingListData = sortTrainingItemsByDate(
    (training || []).filter((item) => item?.documentType !== "certification"),
  );
  const certificationListData = sortTrainingItemsByDate(
    (training || []).filter((item) => item?.documentType === "certification"),
  );

  const renderTrainingSection = (
    items: any[] = [],
    sectionTitle: string,
    dateTitle: React.ReactNode,
  ) => {
    if (!items.length) {
      return null;
    }

    return (
      <div className="mt-5">
        <div className="flex items-center justify-between">
          <div className="text-[15px] font-bold text-gray-900">
            {sectionTitle}
          </div>
          <div className="rounded-full bg-gray-100 px-2.5 py-0.5 text-[12px] font-medium text-gray-600">
            {items.length}
          </div>
        </div>
        <div className="mt-2 overflow-hidden rounded-lg border border-gray-200 bg-white">
          {items.map((item, index) => (
            <div
              key={item?.id}
              className={`bg-white px-3 py-3 ${
                index !== items.length - 1 ? "border-b border-gray-200" : ""
              }`}
            >
              <div className="text-[16px] font-[700] break-words">
                {item?.documentName}{" "}
                <FontAwesomeIcon
                  icon={faPencil}
                  className="pl-1 pr-3 cursor-pointer"
                  onClick={() => {
                    openPopup(4);
                    setpopupType("put");
                    setId(item?.id);
                  }}
                />
              </div>
              <div className="text-[14px] font-[500] mt-1">
                {dateTitle} - {DateFormat(item?.date_attended)}
              </div>
              <div className="mt-2 border-t border-gray-100 pt-2">
                <div className="text-[14px] font-[500] text-gray-800 mt-1">
                  <FormattedMessage
                    id="CLEANER.PROFILE.TRAINING.INPUT.DESCRIPTION.TITLE"
                    defaultMessage="Description"
                  />{" "}
                  - {item?.description || "-"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const getCheckrInvitationLinkOrReCreate = async (cleanerId) => {
    setLoader("loading");
    const getCheckrInvitationLinkRes = await getCheckrInvitationLink(cleanerId);
    setLoader("");
    if (getCheckrInvitationLinkRes.success == true) {
      console.log(getCheckrInvitationLinkRes?.data.invitationLink);
      // setCheckrPackageDetail(getCheckrInvitationLinkRes?.data);
      if (getCheckrInvitationLinkRes?.data.invitationLink) {
        window.open(getCheckrInvitationLinkRes?.data.invitationLink, "_blank");
      } else {
        toast.error("Invitation link not found. Please try again later.");
      }
    }
  };

  const renderCheckrSubtitle = () => {
    if (
      userFullProfile?.user_type_detail &&
      // userFullProfile?.user_type_detail
      //   ?.backgroundCheckVerified != undefined &&
      // userFullProfile?.user_type_detail
      //   ?.backgroundCheckVerified == true &&
      userFullProfile?.user_type_detail?.backgroundCheckStatus != undefined
    ) {
      if (
        [BACKGROUND_CHECK_STATUSES.NOT_STARTED].indexOf(
          userFullProfile?.user_type_detail?.backgroundCheckStatus,
        ) !== -1
      ) {
        return <FormattedMessage id="CLEANER.PROFILE.CHECKR.NOTSTARTED.TEXT" />;
      } else if (
        [
          BACKGROUND_CHECK_STATUSES.INVITED,
          BACKGROUND_CHECK_STATUSES.IN_PROGRESS,
        ].indexOf(userFullProfile?.user_type_detail?.backgroundCheckStatus) !==
        -1
      ) {
        return <FormattedMessage id="CLEANER.PROFILE.CHECKR.INPROGRESS.TEXT" />;
      } else if (
        [
          BACKGROUND_CHECK_STATUSES.CLEAR,
          BACKGROUND_CHECK_STATUSES.CONSIDER,
        ].indexOf(userFullProfile?.user_type_detail?.backgroundCheckStatus) !==
        -1
      ) {
        return (
          <FormattedMessage
            id="CLEANER.PROFILE.CHECKR.CLEAR.TEXT"
            values={{
              price: `${checkrPackageDetail.currencySymbol} ${checkrPackageDetail.price}`,
              duration: `${checkrPackageDetail.duration} ${checkrPackageDetail.durationType}`,
              expiration_date:
                userFullProfile?.user_type_detail?.backgroundCheckStatus !=
                  "NOT_STARTED" &&
                [
                  BACKGROUND_CHECK_STATUSES.CLEAR,
                  BACKGROUND_CHECK_STATUSES.CONSIDER,
                ].indexOf(
                  userFullProfile?.user_type_detail?.backgroundCheckStatus,
                ) !== -1 &&
                userFullProfile?.user_type_detail?.checkrBackgroundCheckDetails
                  ?.status &&
                [
                  BACKGROUND_CHECK_STATUSES.CLEAR,
                  BACKGROUND_CHECK_STATUSES.CONSIDER,
                ].indexOf(
                  userFullProfile?.user_type_detail
                    ?.checkrBackgroundCheckDetails?.status,
                ) !== -1
                  ? ` Valid until ${moment(
                      userFullProfile?.user_type_detail
                        ?.backgroundCheckExpiresAt,
                    ).format("MM/DD/YYYY")}.`
                  : ``,
            }}
          />
        );
      } else if (
        [
          BACKGROUND_CHECK_STATUSES.FAILED,
          BACKGROUND_CHECK_STATUSES.EXPIRED,
        ].indexOf(userFullProfile?.user_type_detail?.backgroundCheckStatus) !==
        -1
      ) {
        return <FormattedMessage id="CLEANER.PROFILE.CHECKR.EXPIRED.TEXT" />;
      }
    }
    return "";
  };
  return (
    <>
      <AuthNavComponent isLoggedin={true}></AuthNavComponent>

      <main className="lg:container lg:flex block mx-auto lg:max-w-6xl lg:mt-10 mt-10 px-4 lg:px-0">
        <div className="w-full">
          {["imagefetch", "checkr", "loading"].indexOf(loader) !== -1 && (
            <LoaderFullScreen
              message={
                loader === "checkr"
                  ? "Don't reload or leave the page."
                  : "Loading..."
              }
            />
          )}
          <ContentWithSpinner loader={loader === "Profile"}>
            <div className="border border-gray-border rounded-xl w-full bg-white text-black pt-10 pb-10">
              <div className="w-full lg:pl-20 lg:flex xl:flex block">
                <div className="">
                  <div className="radius-50 container mx-auto my-auto flex justify-center w-[200px] pt-4">
                    <label htmlFor="imgInput" className="relative">
                      <img
                        alt="Profile"
                        className={`rounded-full w-40 h-40 cursor-pointer`}
                        onMouseEnter={() => setShowReplace(true)}
                        src={` ${
                          profileImg
                            ? profileImg
                            : "/media/icons/displayProfilePlaceholder.png"
                        }`}
                      />
                      {showReplace && (
                        <div
                          onMouseLeave={() => setShowReplace(false)}
                          className="rounded-full w-40 h-40 absolute top-0 bg-[#00000099] inset-auto flex justify-start items-center"
                        >
                          <div>
                            <div className="flex justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-6 h-6 text-white"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                                />
                              </svg>
                            </div>
                            <p className=" text-white text-3xl text-center">
                              Replace photo
                            </p>
                          </div>
                        </div>
                      )}
                    </label>
                    <input
                      onChange={HandleImage}
                      className="hidden"
                      type="file"
                      id="imgInput"
                      name="img"
                      accept="image/*"
                    ></input>
                  </div>
                </div>
                <div className=" text-center lg:pl-10 pt-2 pb-2 lg:text-left lg:w-[70%] w-full ">
                  <div className="border-b-2 border-gray-300 w-100 pb-3">
                    <div className="flex lg:justify-start justify-center space-x-3 items-center">
                      <div className="font-bold text-[24px] flex gap-2 items-center">
                        {cleanerData?.first_name} {cleanerData?.last_name}
                        {((cleanerData?.backgroundCheckStatus != undefined &&
                          [
                            BACKGROUND_CHECK_STATUSES.CLEAR,
                            BACKGROUND_CHECK_STATUSES.CONSIDER,
                          ].indexOf(cleanerData?.backgroundCheckStatus) !==
                            -1) ||
                          userFullProfile?.stripe_customer_model
                            ?.stripe_onboarding_status ===
                            STRIPE_ONBOARDING_STATUSES.SUCCESS) && (
                            <span className="relative group w-6 h-6 inline">
                              <img
                                src="/media/icons/checkr-badge-pink-NB.png"
                                alt="Background check verified"
                                className="w-6 h-6"
                              />

                              {/* Tooltip */}
                              <div className="absolute left-0 top-full pt-2 w-52 hidden group-hover:block z-50">
                                <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                                  Background Check Verified User
                                </div>
                              </div>
                            </span>
                          )}
                      </div>
                      <svg
                        onClick={() => {
                          openPopup(7);
                          setpopupType("put");
                          setId(cleanerData?.id);
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4 cursor-pointer"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                        />
                      </svg>
                    </div>
                    <ContentWithLoader
                      content={<StringLoader />}
                      loading={currentEmployer === null}
                    >
                      <div className="font-700 text-[16px]">
                        {currentEmployer?.job_title}
                      </div>
                    </ContentWithLoader>
                    <ContentWithLoader
                      content={<StringLoader />}
                      loading={currentEmployer === null}
                    >
                      <div className="font-500 text-[14px]">
                        {currentEmployer?.company_name &&
                          "at " + currentEmployer?.company_name}
                      </div>
                    </ContentWithLoader>
                  </div>
                  <div className="mt-4 lg:flex block">
                    <div className="border-r-2 lg:w-[50%] w-full border-gray-300  text-gray-800 lg:float-left lg:pr-12">
                      <div className="flex justify-start space-x-3 items-center">
                        <div className="mt-2 text-[14px] flex-1">
                          <FontAwesomeIcon
                            icon={faMapMarker}
                            className="pl-1 pr-3 cursor-pointer"
                          />
                          {cleanerData?.address?.address_line_1}{" "}
                          {cleanerData?.address?.address_line_2}{" "}
                          {cleanerData?.address?.city}{" "}
                          {cleanerData?.address?.state}
                        </div>
                        <svg
                          onClick={() => {
                            openPopup(7);
                            setpopupType("put");
                            setId(cleanerData?.id);
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-4 h-4 cursor-pointer"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                          />
                        </svg>
                      </div>
                      <div style={{ marginTop: -20 }}>
                        <SmartSearchSelect
                          value={regionId}
                          label=""
                          options={regionId ? [regionId] : []}
                          onChange={handleRegionChange}
                          placeholder="Search for a Region..."
                        />
                      </div>

                      <div className="mt-3 font-700 text-[16px]">
                        <FontAwesomeIcon icon={faBriefcase} className="pr-1" />{" "}
                        {experienceCount &&
                          `${experienceCount?.totalYears} Years ${experienceCount?.totalMonths} Months`}
                      </div>
                    </div>
                    <div className="text-gray-800 lg:w-[50%] w-full lg:float-left lg:pl-12 pl-0">
                      <div className="mt-2 text-[16px] flex space-x-2 items-center justify-center lg:justify-start">
                        <div>
                          <FontAwesomeIcon icon={faPhone} className="pr-3" />
                          {PhoneNumberFormat(cleanerData?.mobile_number)}
                        </div>
                        {cleanerData?.isPhoneVerified === true ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="#0078ae"
                            className="w-6 h-6"
                          >
                            <path
                              fillRule="evenodd"
                              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <>
                            <div className="group relative w-auto">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              <span className="absolute z-10 top-7 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">
                                Not Verified
                              </span>
                            </div>
                            <p
                              onClick={() => {
                                if (
                                  cleanerData?.sms_opt_out === undefined ||
                                  cleanerData?.sms_opt_out === false
                                ) {
                                  handleOtpVerify("sms");
                                } else {
                                  toast.error(
                                    intl.formatMessage({
                                      id: "API.ERROR.NEED.TO.DISABLE.SMSOPTOUT",
                                      defaultMessage:
                                        "Please Opt-In the sms to receive the otp",
                                    }),
                                  );
                                }
                              }}
                              className="text-[#0078ae] font-bold cursor-pointer group relative "
                            >
                              Verify
                              {cleanerData?.sms_opt_out == true && (
                                <span className="absolute w-auto z-10 top-7 left-0 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">
                                  {intl.formatMessage({
                                    id: "API.ERROR.NEED.TO.DISABLE.SMSOPTOUT",
                                    defaultMessage:
                                      "Please Opt-In the sms to receive the otp",
                                  })}
                                </span>
                              )}
                            </p>
                          </>
                        )}
                      </div>
                      <div className="mt-2 text-[16px] flex items-center gap-2 justify-center lg:justify-start">
                        {/* Label */}
                        <div className="whitespace-nowrap">
                          <FormattedMessage
                            id="SMSOPTOUT.LABEL"
                            defaultMessage="SMS Opt out"
                          />
                          {": "}
                          <span className="font-bold">
                            {cleanerData?.sms_opt_out == true ? (
                              <FormattedMessage
                                id="SMSOPTOUT.YES"
                                defaultMessage="Yes"
                              />
                            ) : (
                              <FormattedMessage
                                id="SMSOPTOUT.NO"
                                defaultMessage="No"
                              />
                            )}
                          </span>
                        </div>

                        {/* Button */}
                        {cleanerData?.sms_opt_out === true ? (
                          <Button
                            text={
                              <FormattedMessage
                                id="BTN.TEXT.OPTIN"
                                defaultMessage="Opt-In"
                              />
                            }
                            padding="py-1.5 px-3"
                            outerClass="!w-auto m-0 !mt-0"
                            buttonClass="text-sm"
                            onClick={() => handleOptOutChange(false)}
                          />
                        ) : (
                          <Button
                            text={
                              <FormattedMessage
                                id="BTN.TEXT.OPTOUT"
                                defaultMessage="Opt-Out"
                              />
                            }
                            padding="py-1.5 px-3"
                            outerClass="!w-auto m-0 !mt-0"
                            buttonClass="text-sm"
                            onClick={() => handleOptOutChange(true)}
                          />
                        )}

                        {/* Info icon */}
                        {/* Info icon */}
                        <div className="relative group flex-shrink-0">
                          <span className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-400 text-white text-xs cursor-pointer hover:bg-gray-500 transition">
                            ?
                          </span>

                          {/* Tooltip */}
                          <div className="absolute left-0 top-full pt-2 w-72 hidden group-hover:block z-50">
                            <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                              By opting In, you will receive 1 or more text
                              messages per month related to new job postings,
                              job & work order updates, hiring status, and more.
                              You can update this in your account settings at
                              any time.
                              <br />
                              <br />
                              Message and data rates may apply. Reply STOP to
                              unsubscribe or HELP for help.
                              <br />
                              <br />
                              <a
                                href="https://janijobs.com/privacy-policy/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="underline"
                              >
                                Privacy Policy
                              </a>{" "}
                              and{" "}
                              <a
                                href="https://support.janijobs.com/hc/en-us/articles/42346401405723-JaniJobs-Global-Terms-and-Conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="underline"
                              >
                                Terms & Conditions
                              </a>{" "}
                              apply .
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3 font-700 text-[16px] flex space-x-2 items-center justify-center lg:justify-start  group relative">
                        <div className="">
                          <FontAwesomeIcon icon={faEnvelope} className="pr-1" />{" "}
                          {cleanerData?.email}
                        </div>
                        {isEmailVerified ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="#0078ae"
                            className="w-6 h-6"
                          >
                            <path
                              fillRule="evenodd"
                              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              className="w-5 h-5"
                            >
                              <path
                                fillRule="evenodd"
                                d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                                clipRule="evenodd"
                              />
                            </svg>
                            <span className="absolute z-10 top-10 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">
                              Not Verified
                            </span>
                            <p
                              onClick={() => handleOtpVerify("email")}
                              className="text-[#0078ae] font-bold cursor-pointer"
                            >
                              Verify
                            </p>
                          </>
                        )}
                      </div>

                      <div className="mt-3 font-700 text-[16px] flex space-x-2 items-center justify-center lg:justify-start  group relative">
                        <div className="">
                          <FontAwesomeIcon icon={faLock} className="pr-1" />{" "}
                          {"Change Password"}
                        </div>
                        <svg
                          onClick={() => {
                            setShowPasswordModal(true);
                            setActiveComponent({
                              label: "PasswordChange",
                              componentName: PasswordChangeCleaner,
                              headertitle: (
                                <FormattedMessage
                                  id="CORPORATE.ACCOUNT.SETTINGS.CHANGE_PASSWORD.POPUP.TITLE"
                                  defaultMessage="Change password"
                                />
                              ),
                              icon: faLock,
                            });
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-4 h-4 cursor-pointer"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                          />
                        </svg>
                      </div>
                      <div className="mt-3 font-700 text-[16px] flex space-x-2 items-center justify-center lg:justify-start text-red-500">
                        <div className="">
                          <FontAwesomeIcon icon={faTrash} className="pr-1" />{" "}
                          {"Delete account"}
                        </div>
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="w-4 h-4 cursor-pointer"
                          onClick={() => setShowDeleteAccountModal(true)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ContentWithSpinner>
          <div className="mt-8 rounded-xl w-full text-black  pb-10 lg:flex block">
            <div className="h-full border border-gray-border  rounded-xl lg:w-1/4 w-full bg-white text-black pt-10 lg:p-4 md:p-4 p-4 float-left">
              <div className="w-full text-[18px] font-[700]">
                <FormattedMessage
                  id="CLEANER.PROFILE.QUICKLINKS.TITLE"
                  defaultMessage="Quick Links"
                />
              </div>
              <div className="w-full flex">
                <ul className="w-full">
                  {leftNav?.slice(0, 7)?.map((item: any, i: any) => (
                    <li
                      key={i}
                      className="bg-white w-full hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 flex items-center justify-between hover:border border-gray-400 hover:rounded hover:shadow mt-2"
                      onClick={() => scrollToSection(i)}
                    >
                      <div className="flex-1 min-w-0 pr-2">{item.label}</div>
                      <div
                        className="flex-shrink-0 text-[#0078ae] font-bold cursor-pointer"
                        onClick={
                          item?.label === "Availability" &&
                          availability?.length > 0
                            ? () => {
                                openPopup(i);
                                setpopupType("put");
                                setId(cleanerId);
                              }
                            : () => openPopup(i)
                        }
                      >
                        <FormattedMessage
                          id="CLEANER.PROFILE.ADD.BUTTON"
                          defaultMessage="Add"
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="lg:w-3/4 w-full text-black float-left lg:ml-10 mt-8 lg:mt-0 ml-0">
              <ContentWithSpinner loader={loader === "Resume"}>
                <div className="border border-gray-border  rounded-xl w-full bg-white text-black p-10">
                  <div className="w-full text-[18px] font-[700] inline-block">
                    <div className="float-left">
                      <FormattedMessage
                        id="CLEANER.PROFILE.RESUME.TITLE"
                        defaultMessage="Resume"
                      />
                    </div>
                  </div>

                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.PROFILE.RESUME.TEXT"
                      defaultMessage="Resume is the most important document recruiters look for. Recruiters generally do not look at profiles without resumes."
                    />
                    {resumeName && (
                      <div className="flex items-center justify-between  w-full my-4 px-5">
                        <p className="">{resumeName} </p>
                        <svg
                          onClick={() =>
                            DownloadResume({
                              resumeName: resumeName,
                              resumeKey: resumeKey,
                            })
                          }
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-6 h-6 cursor-pointer"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                          />
                        </svg>
                      </div>
                    )}
                    <p className="text-red-800">{fileerror && fileerror}</p>
                    <div className="flex items-center justify-center w-full mt-2">
                      <label
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        htmlFor="dropzone-file"
                        className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                      >
                        <ContentWithSpinner loader={loader === "Fileupload"}>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload
                              </span>{" "}
                              or drag and drop
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              Supported Formats: doc, docx, rtf, pdf, upto 2 MB
                            </p>
                          </div>
                          <input
                            ref={inputRef}
                            onChange={HandleResume}
                            id="dropzone-file"
                            type="file"
                            className="hidden"
                          />
                        </ContentWithSpinner>
                      </label>
                    </div>
                  </div>
                </div>
              </ContentWithSpinner>
              {/* 

              <div id="section-0" className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block">
                <div className="w-full inline-block font-bold  text-[18px]">
                  <div className="float-left"><FormattedMessage 
  id='CLEANER.PROFILE.DOCUMENT.TITLE'
  defaultMessage='Documents'
/></div>
                  <div className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer" onClick={() => openPopup(0)}>                <FormattedMessage 
  id='CLEANER.PROFILE.ADD.DOCUMENT.TITLE'
  defaultMessage='Add Document'
/> </div>
                </div>
                <div className="w-full text-[14px] font-[500]">
                <FormattedMessage 
  id='CLEANER.PROFILE.DOCUMENT.TEXT'
  defaultMessage='Documents help recruiters know about your identity'
/>


                </div>
                <div className="w-full mt-5 inline-block">
                  <div className="text-[16px] font-[700]">
<FormattedMessage 
  id='CLEANER.PROFILE.DOCUMENT.UPLOADIDPROOF'
  defaultMessage='Upload Id Proof'
/>
 <FontAwesomeIcon icon={faFile} className='pl-3 pr-3 text-[#0078ae] font-bold cursor-pointer' onClick={() => openPopup(0)} /> <FontAwesomeIcon icon={faPencil} className='pl-1 pr-3 cursor-pointer' onClick={() => setShowModal(true)} /></div>
                </div>
                <div className="w-full mt-5 inline-block">
                  <div className="text-[16px] font-[700]"><FormattedMessage 
  id='CLEANER.PROFILE.DOCUMENT.ADDRESSPROOF'
  defaultMessage='Address Proof'
/> <FontAwesomeIcon icon={faPencil} className='pl-1 pr-3 cursor-pointer text-[#0078ae] font-bold cursor-pointer' onClick={() => openPopup(0)} /></div>
                </div>
              </div>               */}
              <ContentWithSpinner loader={loader === "Reference"}>
                <div
                  id="section-2"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      <FormattedMessage
                        id="CLEANER.PROFILE.REFERENCE.TITLE"
                        defaultMessage="Reference"
                      />
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(2)}
                    >
                      <FormattedMessage
                        id="CLEANER.PROFILE.ADDREFERENCE.TITLE"
                        defaultMessage="Add Reference"
                      />
                    </div>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.PROFILE.REFERENCE.TEXT"
                      defaultMessage="Add references to help recruiters learn more about your work experience."
                    />
                  </div>
                  {reference?.map((data, index) => (
                    <div key={data?.id} className="w-full mt-5 inline-block">
                      <div className="text-[16px] font-[700]">
                        {data?.first_name} {data?.last_name}{" "}
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="pl-1 pr-3 cursor-pointer"
                          onClick={() => {
                            openPopup(2);
                            setpopupType("put");
                            setId(data?.id);
                          }}
                        />
                      </div>
                      <div className="text-[14px] font-[500] mt-1">
                        {data?.email}
                      </div>
                      <div className="text-[14px] font-[500] text-gray-800 mt-1">
                        {PhoneNumberFormat(data?.mobile_number)}
                      </div>
                    </div>
                  ))}
                </div>
              </ContentWithSpinner>
              <ContentWithSpinner loader={loader === "Employment"}>
                <div
                  id="section-1"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      <FormattedMessage
                        id="CLEANER.PROFILE.EMLOYMENT.TITLE"
                        defaultMessage="Employment"
                      />
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(1)}
                    >
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.ADDEMLOYMENT.TITLE"
                        defaultMessage="Add Employment"
                      />
                    </div>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.PROFILE.EMLOYMENT.TEXT"
                      defaultMessage="Employment details helps recuiters understand your background"
                    />
                  </div>
                  {employment?.map((data, index) => (
                    <div key={data?.id} className="w-full mt-5 inline-block">
                      <div className="text-[16px] font-[700]">
                        {data?.job_title}{" "}
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="pl-1 pr-3 cursor-pointer"
                          onClick={() => {
                            openPopup(1);
                            setpopupType("put");
                            setId(data?.id);
                          }}
                        />
                      </div>
                      <div className="text-[14px] font-[500] mt-1">
                        {data?.company_name}
                      </div>
                      <div className="text-[14px] font-[500] mt-1">
                        {data?.company_location}
                      </div>
                      <div className="text-[14px] font-[500] text-gray-800 mt-1">
                        {data?.job_type}{" "}
                        {data?.working_since_start && data?.working_since_end
                          ? DateFormat(data?.working_since_start) +
                            "-" +
                            DateFormat(data?.working_since_end)
                          : "Present " + DateFormat(data?.working_since_start)}
                      </div>
                    </div>
                  ))}
                </div>
              </ContentWithSpinner>

              {/* Add/Update Job Type Start*/}
              <ContentWithSpinner loader={loader === "Job Type"}>
                <div
                  id="section-3"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      <FormattedMessage
                        id={
                          jobType?.length > 0
                            ? "CLEANER.PROFILE.EDITJOBTYPE.TITLE"
                            : "CLEANER.PROFILE.ADDJOBTYPE.TITLE"
                        }
                        defaultMessage="Job Type"
                      />
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => {
                        if (jobType?.length > 0) {
                          setpopupType("edit-multiple");
                        } else {
                          setpopupType("add");
                        }
                        openPopup(3);
                      }}
                    >
                      <FormattedMessage
                        id={
                          jobType?.length > 0
                            ? "CLEANER.PROFILE.EDITJOBTYPE.TITLE"
                            : "CLEANER.PROFILE.ADDJOBTYPE.TITLE"
                        }
                        defaultMessage={
                          jobType?.length > 0 ? "Edit Job Type" : "Add Job Type"
                        }
                      />
                    </div>
                  </div>

                  <div className="w-full text-[14px] font-[500]">
                    <h3 className=" text-md">
                      <FormattedMessage
                        id="CLEANER.PROFILE.JOBTYPE.TEXT"
                        defaultMessage="Job Type details helps recuiters understand your Job Type"
                      />
                    </h3>
                  </div>
                  {noresInterested !== false ? (
                    jobType?.map((data, index) => (
                      <div key={index} className="w-full mt-5 inline-block">
                        <div className="text-[16px] font-[700]">
                          {
                            <FormattedMessage
                              id={
                                getLabelByValue(data?.job_type[0], jobTypes) ||
                                "WRONG"
                              }
                            ></FormattedMessage>
                          }{" "}
                          <FontAwesomeIcon
                            icon={faPencil}
                            className="pl-1 pr-3 cursor-pointer"
                            onClick={() => {
                              openPopup(3);
                              setpopupType("put");
                              setId(data?.id);
                            }}
                          />
                        </div>
                        <div className="text-[14px] font-[500] mt-1">
                          {" "}
                          <FormattedMessage
                            id="CLEANER.PROFILE.JOBTYPE.RATE"
                            defaultMessage="Hourly Rate"
                          />{" "}
                          - ${data?.rate}
                        </div>
                        {/* <div className="text-[14px] font-[500] mt-1">
                          {" "}
                          <FormattedMessage
                            id="CLEANER.PROFILE.JOBTYPE.ADDITIONALINFORMATION"
                            defaultMessage="Additional Information"
                          />{" "}
                          {data?.additional_information}
                        </div> */}
                      </div>
                    ))
                  ) : (
                    <p className="pt-4 pb-4">
                      <FormattedMessage id="CLEANER.JOB.TYPE.RESIDENTIAL.INTERESTED"></FormattedMessage>
                    </p>
                  )}

                  {totalPage > 0 && noresInterested !== false && (
                    <Pageination
                      page={page}
                      totalpage={totalPage}
                      limit={limit}
                      onPageChange={handlePageChange}
                    />
                  )}
                </div>
              </ContentWithSpinner>
              {/* Add/Update Job Type End*/}

              <ContentWithSpinner loader={loader === "Training"}>
                <div
                  id="section-4"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full flex items-center justify-between font-bold text-[18px]">
                    <div>
                      <FormattedMessage
                        id="CLEANER.REGISTER.TRAINING_CERTIFICATIONS.TITLE"
                        defaultMessage="Trainings & Certifications"
                      />
                    </div>
                    <button
                      type="button"
                      className="text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(4)}
                    >
                      <FormattedMessage
                        id="CLEANER.PROFILE.ADD.BUTTON"
                        defaultMessage="Add"
                      />
                    </button>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.REGISTER.TRAINING_CERTIFICATIONS.TEXT"
                      defaultMessage="Please enter any recent trainings or certifications you have attended or received."
                    />
                  </div>
                  {renderTrainingSection(
                    trainingListData,
                    intl.formatMessage({
                      id: "CLEANER.REGISTER.TRAINING_CERTIFICATIONS.LIST.TRAININGS",
                      defaultMessage: "Trainings",
                    }),
                    <FormattedMessage
                      id="CLEANER.PROFILE.TRAINING.DATE.ATTENDED"
                      defaultMessage="Date Attended"
                    />,
                  )}
                  {renderTrainingSection(
                    certificationListData,
                    intl.formatMessage({
                      id: "CLEANER.REGISTER.TRAINING_CERTIFICATIONS.LIST.CERTIFICATIONS",
                      defaultMessage: "Certifications",
                    }),
                    <FormattedMessage
                      id="CLEANER.REGISTER.TRAINING_CERTIFICATIONS.DATE.RECEIVED"
                      defaultMessage="Date Received"
                    />,
                  )}
                </div>
              </ContentWithSpinner>
              {/* <ContentWithSpinner loader={loader === "Medical Conditions"}>
                <div
                  id="section-5"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.MEDICALCONDITION.TITLE"
                        defaultMessage="Medical Condition"
                      />{" "}
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(4)}
                    >
                      <FormattedMessage
                        id="CLEANER.PROFILE.MEDICALCONDITION.ADD.TITLE"
                        defaultMessage="Add Medical Condition"
                      />
                    </div>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.PROFILE.MEDICALCONDITION.TEXT"
                      defaultMessage="Medical condition details helps recuiters understand your medical conditions"
                    />
                  </div>
                  {medicalCondition?.map((data: any, index: any) => (
                    <div key={index} className="w-full mt-5 inline-block">
                      <div className="text-[16px] font-[700]">
                        {" "}
                        <FormattedMessage
                          id="CLEANER.PROFILE.MEDICALCONDITION.INPUT.CONDITION"
                          defaultMessage="Condition"
                        />{" "}
                        - {data?.condition}{" "}
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="pl-1 pr-3 cursor-pointer"
                          onClick={() => {
                            openPopup(4);
                            setpopupType("put");
                            setId(data?.id);
                          }}
                        />
                      </div>
                      <div className="text-[14px] font-[500] mt-1">
                        {" "}
                        <FormattedMessage
                          id="CLEANER.PROFILE.MEDICALCONDITION.SINCE.WHEN"
                          defaultMessage="Since When"
                        />{" "}
                        - {DateFormat(data?.since_when)}
                      </div>
                      <div className="text-[14px] font-[500] text-gray-800 mt-1">
                        {" "}
                        <FormattedMessage
                          id="CLEANER.PROFILE.MEDICALCONDITION.DESCRIPTION"
                          defaultMessage="Description"
                        />{" "}
                        - {data?.description}
                      </div>
                    </div>
                  ))}
                </div>
              </ContentWithSpinner> */}
              <ContentWithSpinner loader={loader === "Preferences"}>
                <div
                  id="section-5"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.PREFERENCES.TITLE"
                        defaultMessage="Preferences"
                      />{" "}
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(5)}
                    >
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.ADD.PREFERENCES"
                        defaultMessage="Add Preferences"
                      />
                    </div>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.PROFILE.PREFERENCES.TEXT"
                      defaultMessage="preferences details helps recuiters understand your preferences"
                    />
                  </div>
                  {preference?.map((data: any, index: any) => (
                    <div key={index} className="w-full mt-5 inline-block">
                      <div className="text-[14px] font-[500] mt-1">
                        <FormattedMessage
                          id="INPUT.RADIUS.TITLE"
                          defaultMessage="Radius (in Miles)"
                        />{" "}
                        - {data?.radius}{" "}
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="pl-1 pr-3 cursor-pointer"
                          onClick={() => {
                            openPopup(5);
                            setpopupType("put");
                            setId(data?.id);
                          }}
                        />
                      </div>
                      <div className="text-[14px] font-[500] text-gray-800 mt-1">
                        Shift Type - {data?.shift_type}
                      </div>
                      <div className="text-[14px] font-[500] text-gray-800 mt-1">
                        <FormattedMessage
                          id="CLEANER.PROFILE.PREFERENCES.MINWORKHOURS"
                          defaultMessage="Min hours Work(per week)"
                        />{" "}
                        - {data?.min_hours}
                      </div>
                      <div className="text-[14px] font-[500] text-gray-800 mt-1">
                        <FormattedMessage
                          id="CLEANER.PROFILE.PREFERENCES.MAXWORKHOURS"
                          defaultMessage="Max hours Work(peer week)"
                        />{" "}
                        - {data?.max_hours}
                      </div>
                    </div>
                  ))}
                </div>
              </ContentWithSpinner>
              <ContentWithSpinner loader={loader === "Regions"}>
                <div
                  id="section-5"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.REGIONS.TITLE"
                        defaultMessage="Regions"
                      />{" "}
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(10)}
                    >
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.ADD.REGIONS"
                        defaultMessage="Add Regions"
                      />
                    </div>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage
                      id="CLEANER.PROFILE.REGIONS.TEXT"
                      defaultMessage="Regions details helps recuiters understand your regions"
                    />
                  </div>
                  <div className="p-4 m-4">
                    <div className="mb-6">
                      <div className="w-full text-[14px] font-[600]">
                        <FormattedMessage
                          id="CLEANER.PROFILE.REGIONS.PRIMARY.TITLE"
                          defaultMessage="Primary Region"
                        />
                      </div>
                      <div style={{ marginTop: -25 }}>
                        <SmartSearchSelect
                          value={regionId}
                          label=""
                          options={regionId ? [regionId] : []}
                          onChange={handleRegionChange}
                          placeholder="Search for a Region..."
                        />
                      </div>
                    </div>
                    <div className="w-full text-[14px] font-[600] mb-4">
                      <FormattedMessage
                        id="CLEANER.PROFILE.REGIONS.NEARBY.TITLE"
                        defaultMessage="Additional/Nearby Regions"
                      />
                    </div>
                    {nearbyRegions?.length > 0 ? (
                      <>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {nearbyRegions
                            .slice(0, showAllRegions ? nearbyRegions.length : 6)
                            .map((item: any) => (
                              <div
                                key={item._id}
                                className="border rounded-lg p-3 bg-gray-50 hover:bg-gray-100 transition flex items-center justify-between"
                              >
                                <div>
                                  <h5 className="text-[14px]">
                                    {item.regionId?.city}
                                    {item.regionId?.state
                                      ? ` (${item.regionId.state})`
                                      : ""}
                                  </h5>
                                </div>

                                <FontAwesomeIcon
                                  icon={faTrash}
                                  className="text-gray-400 hover:text-red-500 cursor-pointer pl-2"
                                  onClick={() => handleDeleteRegion(item._id)}
                                />
                              </div>
                            ))}
                        </div>
                        {nearbyRegions.length > 6 && (
                          <div
                            className="mt-4 text-[#0078ae] font-bold cursor-pointer inline-block"
                            onClick={() => setShowAllRegions(!showAllRegions)}
                          >
                            {showAllRegions ? "View Less" : "View All"}
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-center text-gray-500 py-6">
                        No Regions Assigned
                      </div>
                    )}
                  </div>
                </div>
              </ContentWithSpinner>
              {noresInterested !== false && (
                <ContentWithSpinner loader={loader === "Availability"}>
                  <div
                    id="section-6"
                    className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                  >
                    <div className="w-full inline-block font-bold  text-[18px]">
                      <div className="float-left">
                        {" "}
                        <FormattedMessage id="CLEANER.PROFILE.AVAILABILITY.TITLE" />{" "}
                      </div>
                      {(!availability || availability?.length === 0) && (
                        <div
                          className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                          onClick={() => openPopup(6)}
                        >
                          {" "}
                          <FormattedMessage
                            id="CLEANER.PROFILE.ADD.AVAILABILITY"
                            defaultMessage="Add Availability"
                          />
                        </div>
                      )}
                    </div>
                    <div className="w-full text-[14px] font-[500]">
                      <FormattedMessage id="CLEANER.PROFILE.AVAILABILITY.TEXT" />
                    </div>

                    <div className="w-full mt-5 inline-block">
                      {availability?.length > 0 && (
                        <div className="text-[14px] font-[500] mt-1">
                          Edit Availability{" "}
                          <FontAwesomeIcon
                            icon={faPencil}
                            className="pl-1 pr-3 cursor-pointer"
                            onClick={() => {
                              openPopup(6);
                              setpopupType("put");
                              setId(cleanerId);
                            }}
                          />
                        </div>
                      )}
                      {availability
                        ?.sort(
                          (a, b) => Days?.indexOf(a.day) - Days.indexOf(b.day),
                        )
                        .map((item, index) => (
                          <div key={index} className="flex space-x-3">
                            <div> {item?.day}</div>
                            <div className="flex space-x-2">
                              <div>{StringTimeFormat(item?.start_time)} </div>
                              <div> {StringTimeFormat(item?.end_time)}</div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </ContentWithSpinner>
              )}
              {/* <ContentWithSpinner loader={loader === "Availability"}>
                <div
                  id="section-6"
                  className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                >
                  <div className="w-full inline-block font-bold  text-[18px]">
                    <div className="float-left">
                      {" "}
                      <FormattedMessage id="CLEANER.PROFILE.PROFILESUMMARY.TITLE" />{" "}
                    </div>
                    <div
                      className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                      onClick={() => openPopup(8)}
                    >
                      {" "}
                      <FormattedMessage
                        id="CLEANER.PROFILE.ADD.PROFILESUMMARY"
                        defaultMessage="Add Profile Summary"
                      />
                    </div>
                  </div>
                  <div className="w-full text-[14px] font-[500]">
                    <FormattedMessage id="CLEANER.PROFILE.PROFILESUMMARY.TEXT" />
                  </div>

                  <div className="w-full mt-5 inline-block">
                    {availability?.length > 0 && (
                      <div className="text-[14px] font-[500] mt-1">
                        Edit Profile Summary{" "}
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="pl-1 pr-3 cursor-pointer"
                          onClick={() => {
                            openPopup(8);
                            setpopupType("put");
                            setId(cleanerId);
                          }}
                        />
                      </div>
                    )}
                    {availability?.map((item) => (
                      <div className="flex space-x-3">
                        <div> {item?.day}</div>
                        <div className="flex space-x-2">
                          <div>{item?.start_time} </div>
                          <div> {item?.end_time}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </ContentWithSpinner> */}
              {appSettingsData &&
                appSettingsData?.isAllowJobProviderPaymentSettings !=
                  undefined &&
                appSettingsData?.isAllowJobProviderPaymentSettings === true && (
                  <ContentWithSpinner loader={loader === "Availability"}>
                    <div
                      id="payment-settings"
                      className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                    >
                      <div className="w-full inline-block font-bold  text-[18px]">
                        <div className="float-left">
                          {" "}
                          <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.TITLE" />{" "}
                        </div>
                        {(!userFullProfile?.stripe_customer_model ||
                          !userFullProfile?.stripe_customer_model
                            ?.stripe_connect_ac_id ||
                          !userFullProfile?.stripe_customer_model
                            ?.stripe_onboarding_status ||
                          (userFullProfile?.stripe_customer_model
                            ?.stripe_connect_ac_id &&
                            userFullProfile?.stripe_customer_model
                              ?.stripe_onboarding_status &&
                            userFullProfile?.stripe_customer_model
                              ?.stripe_onboarding_status !=
                              STRIPE_ONBOARDING_STATUSES.SUCCESS)) && (
                          <div
                            className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                            onClick={() => openPopup(9)}
                            // onClick={() => {
                            //   setShowPasswordModal(true);
                            //   setActiveComponent({
                            //     label: "PasswordChange1",
                            //     componentName: PasswordChangeCleaner,
                            //     headertitle: (
                            //       <FormattedMessage
                            //         id="CLEANER.PROFILE.STRIPECONNECT.ADD.TEXT"
                            //         defaultMessage="Add my Stripe Account"
                            //       />
                            //     ),
                            //     icon: faLock,
                            //   });
                            // }}
                          >
                            {" "}
                            <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.ADD.TEXT" />
                          </div>
                        )}
                        {isStripeSetupComplete && (
                          <Link
                            to="/cleaner/my-transactions"
                            className="float-right pl-10 text-[#0078ae] font-bold"
                          >
                            Payment History
                          </Link>
                        )}
                      </div>
                      <div className="w-full text-[14px] font-[500]">
                        {isStripeSetupComplete ? (
                          <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.SUCCESS.TEXT" />
                        ) : (
                          <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.TEXT" />
                        )}
                      </div>

                      <div className="w-full mt-5 inline-block">
                        <div className="text-[14px] font-[500] mt-1">
                          {!userFullProfile?.stripe_customer_model ||
                          !userFullProfile?.stripe_customer_model
                            ?.stripe_connect_ac_id ||
                          !userFullProfile?.stripe_customer_model
                            ?.stripe_onboarding_status ||
                          (userFullProfile?.stripe_customer_model
                            ?.stripe_connect_ac_id &&
                            userFullProfile?.stripe_customer_model
                              ?.stripe_onboarding_status &&
                            userFullProfile?.stripe_customer_model
                              ?.stripe_onboarding_status !=
                              STRIPE_ONBOARDING_STATUSES.SUCCESS) ? (
                            <div className="flex space-x-3">
                              <div>
                                <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.STATUS.LABEL" />
                              </div>
                              <div className="flex space-x-2">
                                <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.STATUS.SETUP_REQUIRED" />
                              </div>
                            </div>
                          ) : (
                            <div className="flex flex-col gap-3">
                              <div className="flex space-x-3">
                                <div className="font-bold">
                                  <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.ACCOUNT_ID.LABEL" />
                                </div>
                                <div className="flex space-x-2">
                                  {
                                    userFullProfile?.stripe_customer_model
                                      ?.stripe_connect_ac_id
                                  }
                                </div>
                              </div>
                              <div className="flex space-x-3">
                                <div className="font-bold">
                                  <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.EMAIL.LABEL" />
                                </div>
                                <div className="flex space-x-2">
                                  {
                                    userFullProfile?.stripe_customer_model
                                      ?.stripe_email
                                  }
                                </div>
                              </div>
                              <div className="flex space-x-3">
                                <div className="font-bold">
                                  <FormattedMessage id="CLEANER.PROFILE.STRIPECONNECT.COUNTRY.LABEL" />
                                </div>
                                <div className="flex space-x-2">
                                  {
                                    userFullProfile?.stripe_customer_model
                                      ?.stripe_country
                                  }
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </ContentWithSpinner>
                )}
              {/* Legacy single-package Stripe checkout flow is disabled below. */}
              {isLegacyCheckrCheckoutEnabled && appSettingsData &&
                appSettingsData?.checkr_enable != undefined &&
                appSettingsData?.checkr_enable === true &&
                userFullProfile?.type &&
                userFullProfile?.type == "cleaner" && (
                  <ContentWithSpinner loader={loader === "Availability"}>
                    <div
                      id="checkr-content"
                      className="border border-gray-border  rounded-[18px] w-full bg-white text-black pl-10 pr-10 pt-5 pb-10 mt-8 inline-block"
                    >
                      <div className="w-full inline-block font-bold  text-[18px]">
                        <div className="float-left">
                          {" "}
                          <FormattedMessage
                            id="CLEANER.PROFILE.CHECKR.TITLE"
                            values={{
                              price: `${checkrPackageDetail.currencySymbol} ${checkrPackageDetail.price}`,
                              duration: `${checkrPackageDetail.duration} ${checkrPackageDetail.durationType}`,
                            }}
                          />{" "}
                        </div>
                        {userFullProfile?.type == "cleaner" &&
                          userFullProfile?.user_type_detail &&
                          userFullProfile?.user_type_detail
                            ?.backgroundCheckVerified != undefined &&
                          userFullProfile?.user_type_detail
                            ?.backgroundCheckVerified == false &&
                          userFullProfile?.user_type_detail
                            ?.backgroundCheckStatus != undefined &&
                          ([
                            BACKGROUND_CHECK_STATUSES.NOT_STARTED,
                            BACKGROUND_CHECK_STATUSES.FAILED,
                            BACKGROUND_CHECK_STATUSES.EXPIRED,
                          ].indexOf(
                            userFullProfile?.user_type_detail
                              ?.backgroundCheckStatus,
                          ) !== -1 ||
                            [
                              BACKGROUND_CHECK_STATUSES.NOT_STARTED,
                              BACKGROUND_CHECK_STATUSES.FAILED,
                              BACKGROUND_CHECK_STATUSES.EXPIRED,
                            ].indexOf(
                              userFullProfile?.user_type_detail
                                ?.checkrBackgroundCheckDetails?.status,
                            ) !== -1) && (
                            <div
                              className="float-right pl-10 text-[#0078ae] font-bold cursor-pointer"
                              onClick={async () => {
                                if (
                                  !userFullProfile?.regionDetails ||
                                  !userFullProfile?.regionDetails?.city
                                ) {
                                  toast.error(
                                    intl.formatMessage({
                                      id: "CLEANER.PROFILE.CHECKR.REGION.ERROR",
                                      defaultMessage:
                                        "Please select your primary region before proceeding with the background check.",
                                    }),
                                  );
                                } else {
                                  setLoader("checkr");
                                  let checkrProcessResponse =
                                    await startCheckrProcess({
                                      // return_url: `${window.location.origin}/cleaner/profile`,
                                      return_url: `${window.location.origin}/checker/status`,
                                      cancel_url: `${window.location.origin}/cleaner-profile-page?tab=checkr-content`,
                                    });
                                  if (checkrProcessResponse?.success == true) {
                                    // checkrProcessResponse?.data
                                    if (
                                      checkrProcessResponse?.data &&
                                      checkrProcessResponse?.data?.paymentLink
                                    ) {
                                      window.location =
                                        checkrProcessResponse?.data?.paymentLink;
                                      // window.open(
                                      //   checkrProcessResponse?.data
                                      //     ?.paymentLink,
                                      //   "_blank",
                                      // );
                                    }
                                  } else {
                                    setLoader("");
                                    console.log(
                                      "checkrProcessResponse",
                                      checkrProcessResponse?.data,
                                    );
                                    toast.error(
                                      checkrProcessResponse?.data?.message ||
                                        intl.formatMessage({
                                          id: "CLEANER.PROFILE.CHECKR.ERROR",
                                          defaultMessage:
                                            "An error occurred while starting the Checkr process. Please try again later.",
                                        }),
                                    );
                                  }
                                  setLoader("");
                                  // openPopup(11);
                                }
                              }}
                              // onClick={() => {
                              //   setShowPasswordModal(true);
                              //   setActiveComponent({
                              //     label: "PasswordChange1",
                              //     componentName: PasswordChangeCleaner,
                              //     headertitle: (
                              //       <FormattedMessage
                              //         id="CLEANER.PROFILE.STRIPECONNECT.ADD.TEXT"
                              //         defaultMessage="Add my Stripe Account"
                              //       />
                              //     ),
                              //     icon: faLock,
                              //   });
                              // }}
                            >
                              {" "}
                              <FormattedMessage id="CLEANER.PROFILE.CHECKR.ADD.TEXT" />
                            </div>
                          )}
                      </div>
                      <div className="w-full text-[14px] font-[500]">
                        {renderCheckrSubtitle()}
                      </div>

                      <div className="w-full mt-5 inline-block">
                        <div className="text-[14px] font-[500] mt-1">
                          {userFullProfile?.user_type_detail &&
                            // userFullProfile?.user_type_detail
                            //   ?.backgroundCheckVerified != undefined &&
                            // userFullProfile?.user_type_detail
                            //   ?.backgroundCheckVerified == true &&
                            userFullProfile?.user_type_detail
                              ?.backgroundCheckStatus != undefined &&
                            userFullProfile?.user_type_detail
                              ?.backgroundCheckStatus != "NOT_STARTED" && (
                              <div className="flex flex-col gap-3">
                                <div className="flex space-x-3">
                                  <div className="font-bold">
                                    <FormattedMessage id="CLEANER.PROFILE.CHECKR.LABEL.PLAN" />
                                  </div>
                                  <div className="flex space-x-2">
                                    {
                                      // `${checkrPackageDetail.planTitle} (${moment(userFullProfile?.user_type_detail?.backgroundCheckExpiresAt).format("MM/DD/YYYY")})`
                                      `${checkrPackageDetail.planTitle} (${checkrPackageDetail.duration} ${checkrPackageDetail.durationType})`
                                    }
                                  </div>
                                </div>
                                <div className="flex space-x-3 items-center">
                                  <div className="font-bold">
                                    <FormattedMessage id="CLEANER.PROFILE.CHECKR.LABEL.STATUS" />
                                  </div>
                                  <div className="flex items-center gap-2">
                                    {(
                                      userFullProfile?.user_type_detail
                                        ?.checkrBackgroundCheckDetails
                                        ?.status ||
                                      userFullProfile?.user_type_detail
                                        ?.backgroundCheckStatus
                                    )?.replaceAll("_", " ")}
                                    {userFullProfile?.user_type_detail
                                      ?.backgroundCheckStatus !=
                                      "NOT_STARTED" &&
                                    [BACKGROUND_CHECK_STATUSES.INVITED].indexOf(
                                      userFullProfile?.user_type_detail
                                        ?.backgroundCheckStatus,
                                    ) !== -1 &&
                                    userFullProfile?.user_type_detail
                                      ?.checkrBackgroundCheckDetails?.status &&
                                    [BACKGROUND_CHECK_STATUSES.INVITED].indexOf(
                                      userFullProfile?.user_type_detail
                                        ?.checkrBackgroundCheckDetails?.status,
                                    ) !== -1 &&
                                    checkrInvitationDetail?.expires_at ? (
                                      <>
                                        {` (Invite Valid until ${moment(
                                          checkrInvitationDetail?.expires_at,
                                        ).format("MM/DD/YYYY hh:mm A")})`}
                                        {moment().isSameOrBefore(
                                          moment(
                                            checkrInvitationDetail?.expires_at,
                                          ),
                                        ) && (
                                          <Button
                                            text={
                                              <FormattedMessage
                                                id="CLEANER.PROFILE.CHECKR.ADD.TEXT"
                                                defaultMessage="Get new invitation"
                                              />
                                            }
                                            padding="py-1.5 px-3"
                                            outerClass="!w-auto m-0 !mt-0"
                                            buttonClass="text-sm"
                                            onClick={() => {
                                              getCheckrInvitationLinkOrReCreate(
                                                userFullProfile
                                                  ?.user_type_detail._id,
                                              );
                                            }}
                                          />
                                        )}
                                        {moment().isAfter(
                                          moment(
                                            checkrInvitationDetail?.expires_at,
                                          ),
                                        ) && (
                                          <Button
                                            text={
                                              <FormattedMessage
                                                id="CLEANER.PROFILE.CHECKR.BTN.NEWINVITE"
                                                defaultMessage="Get new invitation"
                                              />
                                            }
                                            padding="py-1.5 px-3"
                                            outerClass="!w-auto m-0 !mt-0"
                                            buttonClass="text-sm"
                                            onClick={() => {
                                              getCheckrInvitationLinkOrReCreate(
                                                userFullProfile
                                                  ?.user_type_detail._id,
                                              );
                                            }}
                                          />
                                        )}
                                      </>
                                    ) : (
                                      ``
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </ContentWithSpinner>
                )}
              {userFullProfile?.type === "cleaner" && (
                <ContentWithSpinner loader={loader === "Payment settings"}>
                  <div className="mt-8 inline-block w-full rounded-[18px] border border-gray-border bg-white px-6 pb-8 pt-5 text-black sm:px-10">
                    <Payment userType="cleaner" />
                  </div>
                </ContentWithSpinner>
              )}
              {appSettingsData?.cleanerCheckrEnable === true &&
                appSettingsData?.checkr_enable === true &&
                userFullProfile?.type === "cleaner" && (
                  <CleanerBackgroundCheck />
                )}
            </div>
          </div>
        </div>

        {/* modal popup */}
        {showPasswordModal ? (
          <ModelWrapperWithButton
            Save={HandleChange}
            showModal={showPasswordModal}
            onCheckModel={HandleModel}
            headertitle={activeComponent?.headertitle}
          >
            {activeComponent?.componentName && (
              <activeComponent.componentName
                ref={childRef}
                HandleModel={HandleModel}
                onOtpSent={() => {}}
              />
            )}
          </ModelWrapperWithButton>
        ) : null}

        <ModelWrapperWithButton
          isDelete={
            id && activeComponent.label !== "Personal Details" ? true : false
          }
          HandleDelete={HandleDelete}
          Save={handleButtonClick}
          headertitle={`${popuptype === "edit-multiple" ? "Edit" : "Add"} ${
            activeComponent.label
          }`}
          showModal={showModal}
          nofooter={activeComponent.label === "Regions"}
          onCheckModel={onCheckModel}
          onReload={() => setReload(!reload)}
        >
          {popuptype === "put" && id ? (
            <activeComponent.componentName
              page="popup"
              type="put"
              id={id}
              ref={childRef}
              dataAddedHandle={dataAddedHandle}
            />
          ) : popuptype === "edit-multiple" ? (
            <activeComponent.componentName
              page="popup"
              type="edit-multiple"
              ref={childRef}
              dataAddedHandle={dataAddedHandleEditMultiple}
            />
          ) : (
            <activeComponent.componentName
              page="popup"
              type="add"
              ref={childRef}
              dataAddedHandle={dataAddedHandle}
            />
          )}
        </ModelWrapperWithButton>

        <ModelWrapperWithButton
          nofooter={true}
          showModal={showVerify}
          onCheckModel={() => setShowVerify(false)}
        >
          <VerifyOTP
            otpsuccess={() => {
              if (channel === "email") {
                clearEmailVerificationPending("cleaner", userId);
              }
              setShowVerify(false);
              setChannel("");
              fetchCleaner(userId);
            }}
            type="popup"
            channel={channel}
            authRequired={true}
          ></VerifyOTP>
        </ModelWrapperWithButton>

        <ModelWrapperWithButton
          Save={handleDeleteAccount}
          showModal={showDeleteAccountModal}
          onCheckModel={setShowDeleteAccountModal}
          headertitle="Delete account"
          loader={deleteAccountLoader}
          savetext="Delete account"
        >
          <div>
            <p className="mb-4">
              Are you sure you want to delete your account? This action cannot
              be undone.
            </p>
            <label className="block font-bold mb-2">Reason</label>
            <textarea
              value={deleteReason}
              onChange={(e) => setDeleteReason(e.target.value)}
              placeholder="Enter your reason"
              className="w-full min-h-[120px] border border-neutral-300 rounded-lg p-3"
            />
          </div>
        </ModelWrapperWithButton>
      </main>

      <Footer />
    </>
  );
}
